<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
const router = useRouter();
const { t } = useI18n({ useScope: 'global' });
</script>

<template>
  <div class="rs">
    <div class="rs__icon-wrap">
      <i class="pi pi-check-circle rs__icon" />
    </div>

    <h2 class="rs__title">{{ t('auth.resetSuccess.title') }}</h2>
    <p class="rs__subtitle">{{ t('auth.resetSuccess.subtitle') }}</p>

    <button class="rs__btn" @click="router.push('/login')">
      {{ t('auth.resetSuccess.submit') }}
    </button>
  </div>
</template>

<style scoped>
.rs {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  text-align: center;
  width: 100%;
}

.rs__icon-wrap {
  width: 5rem;
  height: 5rem;
  border-radius: 1.5rem;
  background: rgba(22, 163, 74, 0.12);
  border: 1px solid rgba(22, 163, 74, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

.rs__icon {
  font-size: 3rem;
  color: #16a34a;
}

.rs__title {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--nxt-on-surface, #191c1d);
  letter-spacing: -0.01em;
}

.rs__subtitle {
  margin: 0;
  font-size: 0.9375rem;
  color: var(--nxt-on-surface-variant, #564335);
  max-width: 300px;
  line-height: 1.6;
}

.rs__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  height: 54px;
  margin-top: 0.5rem;
  border-radius: 9999px;
  border: none;
  background: linear-gradient(135deg, #ffd60a 0%, #f5c500 100%);
  box-shadow:
    0 4px 20px rgba(255, 214, 10, 0.4),
    0 1px 0 rgba(255, 255, 255, 0.4) inset;
  color: #0b1320;
  font-size: 1rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  letter-spacing: -0.01em;
  transition:
    box-shadow 0.2s,
    transform 0.1s;
}
.rs__btn:hover {
  box-shadow:
    0 6px 28px rgba(255, 214, 10, 0.55),
    0 1px 0 rgba(255, 255, 255, 0.4) inset;
}
.rs__btn:active {
  transform: scale(0.985);
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
